// src/components/CorporateTravelFormModal.js
import React, { useState } from "react";
import Modal from "react-modal";
import emailjs from "@emailjs/browser";
import "./CorporateTravelForm.css";

Modal.setAppElement("#root");

const CorporateTravelFormModal = ({ isOpen, onRequestClose }) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;
    const formData = {
      name: form.name.value,
      email: form.email.value,
      destination: form.destination.value,
      travelDates: form.travelDates.value,
      numPeople: form.numPeople.value,
      purpose: form.purpose.value,
      message: form.message.value,
      form_type: "Corporate Travel",
    };

    emailjs
      .send(
        "service_rkd3nje",
        "template_t8nu1ry",
        formData,
        "jb85tG8nJgXDnDBVa"
      )
      .then(() => {
        setLoading(false);
        setSubmitted(true);
        setTimeout(() => {
          setSubmitted(false);
          onRequestClose();
        }, 2500);
      })
      .catch(() => {
        setLoading(false);
        alert("Something went wrong. Please try again.");
      });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Corporate Travel Form"
      overlayClassName="corporate-form-overlay"
      className="corporate-form-modal"
    >
      {submitted ? (
        <div className="thank-you-message">
          <span>✅</span>
          <h2>Thank you!</h2>
          <p>Your inquiry has been submitted.</p>
        </div>
      ) : (
        <>
          <button className="form-close-button" onClick={onRequestClose}>
            ×
          </button>
          <h2 className="form-title">Plan My Corporate Trip</h2>
          <form onSubmit={handleSubmit} className="corporate-form">
            <input type="text" name="name" placeholder="Your Name" required />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              required
            />
            <input
              type="text"
              name="destination"
              placeholder="Destination"
              required
            />
            <input
              type="text"
              name="travelDates"
              placeholder="Travel Dates"
              required
            />
            <input
              type="number"
              name="numPeople"
              placeholder="No. of Travelers"
              required
            />
            <select name="purpose" required>
              <option value="">Purpose of Trip</option>
              <option value="Conference">Conference</option>
              <option value="Business Meeting">Business Meeting</option>
              <option value="Team Outing">Team Outing</option>
              <option value="Leisure">Leisure</option>
            </select>
            <textarea
              name="message"
              placeholder="Additional Details (Optional)"
              rows="4"
            />
            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </>
      )}
    </Modal>
  );
};

export default CorporateTravelFormModal;
